export default "__VITE_ASSET__d929fa28__"